import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { TRATAMENTO_PRIORITARIO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    TRATAMENTO_PRIORITARIO_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    TRATAMENTO_PRIORITARIO_ENDPOINT,
    id
  ]);
}
